import { Component } from '@angular/core';
import { SkeletonBlockComponent } from '../skeleton-block/skeleton-block.component';

@Component({
  selector: 'app-timeline-skeleton',
  standalone: true,
  imports: [SkeletonBlockComponent],
  templateUrl: './timeline-skeleton.component.html',
  styleUrls: ['./timeline-skeleton.component.scss'],
})
export class TimelineSkeletonComponent {
  // Placeholder month columns to mimic the timeline axis
  months = Array(6);

  // Placeholder cards per row
  aboveCards = Array(3);
  belowCards = Array(3);
}
